<template>
  <section class="ant-layout">
    <main class="ant-layout-content">
      <div class="ant-spin-nested-loading">
        <div class="ant-spin-container">
          <div class="betting-record-page">
            <div class="common-header">
              <font style="vertical-align: inherit"><font style="vertical-align: inherit"> {{ $t('mine.Transactionhistory') }} </font></font>
            </div>
            <div class="search-options-wrapper">
              <div id="betting-create-selector">
                <div class="common-search-item">
                  <div class="common-search-item-name">
                    <font style="vertical-align: inherit"><font style="vertical-align: inherit"> {{$t('mine.Selectplatform')}}   </font></font>
                  </div>
                  <div class="common-search-item-content">
                    <el-select size="mini" v-model="api_type" :placeholder="$t('mine.Selectplatform')" @change="changApiType">
                      <el-option v-for="(item, index) in dogameLis" :key="index" :label="item.name" :value="item.platname"> </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div id="betting-create-selector">
                <div class="common-search-item">
                  <div class="common-search-item-name">
                    <font style="vertical-align: inherit"><font style="vertical-align: inherit"> {{$t('mine.Transactiontype')}}  </font></font>
                  </div>
                  <div class="common-search-item-content">
                    <div>
                      <el-radio-group v-model="type" size="mini" @change="changeDate">
                        <el-radio-button :label="1">{{$t('mine.osit')}}</el-radio-button>
                        <el-radio-button :label="2">{{$t('mine.Withdrawal1')}}</el-radio-button>
                        <el-radio-button :label="3">{{$t('mine.transferin')}}</el-radio-button>
                        <el-radio-button :label="4">{{$t('mine.transferout')}}</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
              </div>
              <div id="betting-create-selector">
                <div class="common-search-item">
                  <div class="common-search-item-name">
                    <font style="vertical-align: inherit"><font style="vertical-align: inherit"> {{$t('mine.Timerange')}} </font></font>
                  </div>
                  <div class="common-search-item-content">
                    <div>
                      <el-radio-group v-model="date" size="mini" @change="changeDate">
                        <el-radio-button :label="1">{{$t('mine.today')}}</el-radio-button>
                        <el-radio-button :label="2">{{$t('mine.week')}}</el-radio-button>
                        <el-radio-button :label="3">{{$t('mine.month')}}</el-radio-button>
                        <el-radio-button :label="4">{{$t('mine.onemonth')}}</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="list-wrapper" style="margin-top: 16px">
              <div class="ant-table-wrapper">
                <div class="ant-spin-nested-loading">
                  <div class="ant-spin-container">
                    <div class="ant-table">
                      <div class="ant-table-container">
                        <div class="ant-table-content">
                          <table style="table-layout: auto">
                            <colgroup></colgroup>
                            <thead class="ant-table-thead">
                              <tr>
                                <th class="ant-table-cell col-api-type-id">{{$t('mine.number')}}</th>
                                <th class="ant-table-cell col-single-amount">{{$t('mine.time')}}</th>
                                <th class="ant-table-cell col-effective-trade-amount" v-if="type == 1 || type == 2">{{$t('mine.Ordernumber')}}</th>
                                <th class="ant-table-cell col-profit-amount">{{$t('mine.Transactiontypea')}}</th>
                                <th class="ant-table-cell col-profit-amount">{{$t('mine.Amount')}}</th>
                                <th class="ant-table-cell col-profit-amount">{{$t('mine.Status')}}</th>
                              </tr>
                            </thead>
                            <tbody class="ant-table-tbody" v-if="transrecordList.length > 0">
                              <tr class="ant-table-placeholder" v-for="(item, index) in transrecordList" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.created_at }}</td>
                                <td v-if="type == 1 || type == 2">{{ item.out_trade_no }}</td>
                                <td>{{ item.pay_way }}</td>
                                <td>{{ item.amount }}</td>
                                <td class="left" v-if="type == 1 || type == 2">
                                  {{ stateType12[item.state] }}
                                </td>
                                <td class="left" v-if="type == 3 || type == 4">
                                  {{ stateType34[item.state] }}
                                </td>
                              </tr>
                            </tbody>
                            <tbody class="ant-table-tbody" v-if="transrecordList.length == 0">
                              <tr class="ant-table-placeholder">
                                <td colspan="8" class="ant-table-cell">
                                  <div class="empty-content">
                                    <span
                                      ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('mine.Nodata')}}</font></font></span
                                    >
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <el-pagination v-if="transrecordListShowData.total" style="margin: 20px 0 0px 120px" @current-change="getTransrecord" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="transrecordListShowData.total"></el-pagination>
                          <div style="height: 30px"></div>
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
export default {
  name: 'fanshui',
  data() {
    return {
      date: 4,
      transrecordList: [],
      transrecordListShowData: {},
      type: 1,
      page: 1,
      stateType12: ['未定义', '待审核', '审核通过', '审核拒绝'],
      stateType34: ['失败', '成功', '待结算', '未定义'],
      dogameLis: [],
      api_type: '',
    };
  },
  created() {
    let that = this;

    that.stateType12 = [that.$t('mine.undefined'),that.$t('mine.reviewed'),that.$t('mine.Approved'),that.$t('mine.Audit')]
    that.stateType34 = [that.$t('mine.Failed'),that.$t('mine.success'),that.$t('mine.settled'),that.$t('mine.undefined')]
    that.getdogame();
    that.getTransrecord();
  },
  methods: {
    changApiType() {
      let that = this;
      that.page = 1;
      that.getTransrecord();
    },
    getdogame() {
      let that = this;

      that.$apiFun.post('/api/balancelist', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.dogameLis = res.data;
          that.dogameLis.unshift({ name: that.$t('mine.platforms'), platname: '' });
        }
      });
    },
    changeDate() {
      let that = this;
      that.page = 1;
      that.getTransrecord();
    },

    // 获取交易记录
    getTransrecord() {
      let that = this;
      that.$parent.showLoading();

      let info = {
        date: that.date,
        type: that.type,
        page: that.page,
        api_type: that.api_type,
      };
      that.$apiFun
        .post('/api/gettransrecord', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.transrecordList = res.data.data;
            that.transrecordListShowData = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/betting.css';
.spinner {
  width: 1em;
  height: 1em;
  position: relative;
  font-size: 200px;
  margin: 0 auto;
}

.spinner .line {
  width: 0.15em;
  height: 5px;
  border-radius: 5px;
  background-color: #b5b5b6;
  animation: spinner-line 1s infinite;
  position: absolute;
  right: 0;
  bottom: -0.1em;
}

.spinner svg {
  width: 1.2em;
  height: 1.2em;
  position: absolute;
  top: -0.1em;
  left: -0.1em;
  animation: spinner-jerry-fish 1s infinite;
  z-index: 1;
}

.spinner p {
  width: 100%;
  position: absolute;
  bottom: calc(-0.1em - 40px);
  text-align: center;
  height: 40px;
  line-height: 40px;
  margin: unset;
  display: flex;
  justify-content: center;
}

.spinner p span {
  font-size: 14px;
  color: #c9caca;
}

.spinner .circle {
  width: 1em;
  height: 1em;
  border-radius: 50%;
}

.spinner .circle i {
  position: absolute;
  left: 0;
  clip: rect(0, 1em, 1em, 0.5em);
  width: 1em;
  height: 1em;
  animation: spinner-circle-clipper linear 1s infinite;
}

.spinner .circle i:after {
  position: absolute;
  left: 0;
  clip: rect(0, 1em, 1em, 0.5em);
  width: 1em;
  height: 1em;
  content: '';
  animation: spinner-circle 1s linear infinite;
  border-radius: 50%;
  box-shadow: inset 0 0 0 4px #c9caca;
}

@keyframes spinner-circle-clipper {
  0% {
    transform: rotate(0deg);
  }
  30% {
    transform: rotate(60deg);
  }
  50% {
    transform: rotate(60deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes spinner-circle {
  0% {
    transform: rotate(-180deg);
  }
  5% {
    transform: rotate(-170deg);
  }
  30% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(30deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes spinner-jerry-fish {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-line {
  0% {
    opacity: 0;
    right: 0;
  }
  5% {
    opacity: 0.2;
  }
  10% {
    opacity: 0.4;
  }
  15% {
    opacity: 0.6;
  }
  20% {
    opacity: 0.8;
  }
  25% {
    opacity: 1;
  }
  30% {
    opacity: 1;
  }
  35% {
    opacity: 0.8;
  }
  40% {
    opacity: 0.6;
  }
  45% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.3;
  }
  55% {
    opacity: 0.2;
  }
  60% {
    opacity: 0.1;
  }
  65% {
    opacity: 0;
    right: calc(100% - 0.25em);
  }
  100% {
    opacity: 0;
    right: 0;
  }
}
.active {
  color: #fff !important;
}
.ant-table-thead > tr > th {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/transRecord.vue